import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { map, of } from "rxjs";
import { CompanyService } from "src/app/company/services/company.service";
import { IBaseSearchRequest } from "src/app/core/models/base";

export function CompanyTenantIdValidator(companyService: CompanyService): AsyncValidatorFn {
    return  (control: AbstractControl) => {
        const request : IBaseSearchRequest= {
            pageNumber:0,
            pageSize: 999999,
            advancedFilter:{
                logic: "and",
                filters: [
                    {
                        field: 'tenantId',
                        operator: 'eq',
                        value: control.value

                    }
                ]
            }
        }
        // check if form has yet been changed
        // prevent unessecary api call and inital error message
        if(!control.pristine){
          return companyService.listCompanies(request)
          .pipe(
              map(response => {
                  const companys = response.data;
                  return companys.length != 0 ? {companyTenantIdExists: true} : null;
              })
          )
        } else {
          return of(null);
        }

    
        
    }
}
